package mobile.icard.ICardRoomDatabase

import kotlin.ByteArray
import kotlin.Double
import kotlin.Long
import kotlin.String

public data class Embeddings(
  public val merchantLocationId: Long,
  public val cityId: Long,
  public val lang: String,
  public val docType: String,
  public val qScale: Double,
  public val qZeroPoint: Long,
  public val vecQint8: ByteArray,
  public val lastModifiedIso: String,
)
